module.exports = __webpack_public_path__ + "static/media/next.1b8b96e3.svg";